module.exports = __webpack_public_path__ + "static/media/header-img.de36d5b7.png";